import {isWellSample} from 'constants/SampleConstants';
import {SampleDetailsWithOptionalStageRunSample} from 'workflows/util/StageRunUtil';

/**
 * Computes a canonical identifier for a sample (specifically, a SampleDetails object).
 *
 * This is not intended to be persisted; only to be used in the FE for deduplication and cross-referencing.
 */
export default function getSampleKey(sample: SampleDetailsWithOptionalStageRunSample): string {
  return [
    sample.stageRun?.id,
    sample.bioentityInfo?.id,
    sample.batchInfo?.id,
    sample.boxInfo?.id,
    sample.containerInfo?.id,
    sample.textInfo?.id,
    sample.numberInfo?.id,
    sample.booleanInfo?.id,
    sample.plateInfo?.id,
    isWellSample(sample)
      ? typeof sample.position === 'string'
        ? sample.position
        : `${sample.position.columnIndex}!${sample.position.rowIndex}`
      : null,
    // We include the sample's error state in its key, because there can be two cells in the same column with the same value and different error states if the column has custom eval depending on another column in the row.
    sample.error ? true : null,
  ]
    .map((value) => value ?? '.')
    .join('');
}
